<template>
    <confirmation-popup
        ref="popup"
        v-bind:title="resource('DmVisualizer_ScenarioDeactivationConfirmationPopup_Title')"
        v-bind:texts="{ header: scenario.batchCancellationTextHeader, body: scenario.batchCancellationText }">
        <button 
            class="btn btn-warning"
            @click="$emit('confirm')"
        >
            {{resource('DmVisualizer_ScenarioDeactivationConfirmationPopup_ConfirmationButtonText')}}
        </button>
    </confirmation-popup>
</template>

<script>
    import resourceMixin from '../../../../Util/Mixins/resources'
    
    import ConfirmationPopup from "./../ConfirmationPopup.vue";

    export default {
        name: "scenario-deactivation-popup",
        mixins: [resourceMixin],
        components: {ConfirmationPopup},
        methods: {
            show(){
                this.$refs.popup.show();
            },
            hide(){
                this.$refs.popup.hide();
            }
        },
        props: {
            scenario: {
                type: Object,
                required: true,
                default: () => ({
                    batchCancellationTextHeader: '',
                    batchCancellationText: ''
                })
            }
        }
    }
</script>
